module.exports = __webpack_public_path__ + "static/img/gamebanner2.193eba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/gamebanner2.png
// module id = TkL0
// module chunks = 0